import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { Dialog } from "../../../components/Dialog";
import PrizeDrawIcon from "../../../assets/campaign/prize-draw.webp";

type ConfirmateAwardedProps = {
  open: boolean;
  onClose: () => void;
  onBack: () => void;
};

export function ConfirmateAwarded({
  onBack,
  onClose,
  open,
}: ConfirmateAwardedProps) {
  return (
    <Dialog fullWidth maxWidth="xs" open={open}>
      <DialogContent>
        <img alt="prize-draw" style={{ width: "100%" }} src={PrizeDrawIcon} />
        <DialogContentText align="center" id="alert-dialog-awarded-description">
          Após o início do sorteio, não será possível editar ou refazer a ação.
          🔐
          <br /> <br />
          Para garantir a confiabilidade do sorteio, pedimos permissão para
          gravar a tela do sistema. 🥺
          <br /> <br />
          Você também pode narrar o sorteio, é só autorizar o uso do microfone.
          😉
        </DialogContentText>
      </DialogContent>
      <DialogActions
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Button onClick={onBack} variant="text" fullWidth color="inherit">
          Voltar
        </Button>
        <Button onClick={onClose} variant="contained" fullWidth color="primary">
          Iniciar premiação
        </Button>
      </DialogActions>
    </Dialog>
  );
}
